document.addEventListener(
  "click",
  function (e) {
    if (window.innerWidth >= 990) return;

    const summary = e.target.closest("summary[data-nav-drawer-summary]");
    if (!summary) return;

    if (
      e.target.closest("[data-menu-button]") ||
      e.target.closest("[data-menu-close-button]")
    ) {
      return;
    }

    const details = summary.closest("details");
    if (!details) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    const isOpening = !details.open;
    details.open = isOpening;

    // If opening a top-level item like SHOP, auto-open its children
    if (isOpening) {
      requestAnimationFrame(() => {
        details.querySelectorAll(".nav-drawer__tier-2-item details").forEach((child) => {
          child.open = true;
        });
      });
    } else {
      requestAnimationFrame(() => {
        details.querySelectorAll(".nav-drawer__tier-2-item details").forEach((child) => {
          child.open = false;
        });
      });
    }
  },
  true
);